/** Returns the URL's protocol, or undefined when it can't be parsed. */
export function protocolOf(source: string): string | undefined {
  try {
    return new URL(source, globalThis.location?.href).protocol;
  } catch {
    return undefined;
  }
}
